import request from '@/utils/request.js';

// 我的游戏圈
export const getUserGameCircles = () => request({ url: '/v1/game_circle/my', method: 'get' });

// 获取游戏圈板块及游戏圈列表
export const getCircleList = () => request({ url: '/v1/game_circle/list', method: 'get' });

// 发贴时候可选游戏圈列表
export const getIssueCircleList = () =>
  request({
    url: '/v1/game_circle/option',
    method: 'get',
  });
